import * as React from 'react';
var RadioGroupContext = /*#__PURE__*/React.createContext(null);
export var RadioGroupContextProvider = RadioGroupContext.Provider;
export default RadioGroupContext;